import {UUID} from '../../../shared/types/uuid.type';
import {createReducer, on} from '@ngrx/store';
import {
  clearVmixServersState,
  loadVmixServers,
  loadVmixServersFailure,
  loadVmixServersSuccess,
  manyProductionInstancesStatusChanged,
  productionInstanceDeleted,
  productionInstanceUpdated
} from '../actions/vmix-servers.actions';
import {ProductionInstance, ProductionInstancesStatus} from '../../../services/api/production-instances/production-instance.model';

export const vmixServersFeatureKey = 'vmixServers';

export interface State {
  record: ProductionInstance[];
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: [],
  error: null,
  loaded: false,
  loading: false
};


export const reducer = createReducer(
  initialState,

  on(loadVmixServers, (state: State): State => ({
    ...state,
    error: null,
    loaded: false,
    loading: true
  })),
  on(loadVmixServersSuccess, (_state: State, action: { data: ProductionInstance[] }): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false
  })),
  on(productionInstanceUpdated, (state: State, action: { data: ProductionInstance }): State => {
    const instancesList: ProductionInstance[] = state.record.slice();
    const updatedInstance: ProductionInstance = action.data;
    const updatedInstanceId: UUID = updatedInstance.id;

    const index: number = instancesList
      .findIndex((item: ProductionInstance): boolean => item.id === updatedInstanceId);
    if (index !== -1) {
      instancesList[index] = updatedInstance;
    } else {
      instancesList.push(updatedInstance);
    }

    return {
      record: instancesList,
      error: null,
      loaded: true,
      loading: false
    };
  }),
  on(manyProductionInstancesStatusChanged, (state: State, action: { ids: UUID[]; status: ProductionInstancesStatus }): State => {
    const instanceIds: UUID[] = action.ids;
    const newStatus: ProductionInstancesStatus = action.status;

    const instancesList: ProductionInstance[] = state.record
      .map((item: ProductionInstance): ProductionInstance => {
        const id: UUID = item.id;
        if (instanceIds.includes(id)) {
          return {...item, status: newStatus}; // Update status
        }

        return item; // Return unchanged item
      });

    return {
      record: instancesList,
      error: null,
      loaded: true,
      loading: false
    };
  }),
  on(productionInstanceDeleted, (state: State, action: { id: UUID }): State => {
    const instancesList: ProductionInstance[] = state.record.slice();
    const instanceId: UUID = action.id;

    const index: number = instancesList
      .findIndex((item: ProductionInstance): boolean => item.id === instanceId);
    if (index !== -1) {
      instancesList.splice(index, 1);
    }

    return {
      record: instancesList,
      error: null,
      loaded: true,
      loading: false
    };
  }),
  on(loadVmixServersFailure, (_state: State, action: { error: any }): State => ({
    record: [],
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearVmixServersState, (): State => ({
    record: [],
    error: null,
    loaded: false,
    loading: false
  }))
);
